/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from "react";

import { useAtualizarIndicadores } from "services/api";
import { Skeleton } from "@mui/material";
import { PiHandbagSimpleDuotone } from "react-icons/pi";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { useGetEtapas } from "services/api/Etapas_Subetapas/etapas-get";
import { CARGO_CODES } from "constants/permissions";
import {
  TipoAgendamento,
  useIndicadoresAgendamentoTotal,
} from "services/api/Common_Leads/indicadores-agendamento";
import * as IconsSVG from "../../../../assets/iconsSVG";
import CyrelaLogo from "../../../../assets/logo/cyrela_logo.jpg";
import axiosLead from "../../../../services/lead";
import * as Styles from "../../styles";
import CardIndicator from "../cardIndicator";
import PerformanceModal from "./performanceModal";
import * as WeekStyles from "./AgendamentoDetails/styles";
import { formatIntervaloSemana } from "../../../../utils/intervaloSemana";

interface Props {
  codigoCargo2013: string | null;
}

const Indicators = (props: Props) => {
  const [tabValue, setTabValue] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [indicators, setIndicators] = useState<any>([]);
  const [temperaturas, setTemperaturas] = useState<any>([]);
  const [performanceModal, setPerformanceModal] = useState(false);
  const [performanceModalTab, setPerformanceModalTab] = useState(0);
  const [semanaAgendamento, setSemanaAgendamento] = useState(true);
  const { usuarioGerenteOnline } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );

  const { data: indicadorVisita } = useIndicadoresAgendamentoTotal({
    queryKey: `home-indicador-visita-${semanaAgendamento}`,
    tipoAgendamento: TipoAgendamento.Visita,
    semanaAtual: semanaAgendamento,
  });
  const { data: indicadorAssinatura } = useIndicadoresAgendamentoTotal({
    queryKey: `home-indicador-assinatura-${semanaAgendamento}`,
    tipoAgendamento: TipoAgendamento.Assinatura,
    semanaAtual: semanaAgendamento,
  });

  const isCorretorHome = props.codigoCargo2013 === CARGO_CODES.CORRETOR;

  const abrirDetalhes = (tab: number) => {
    setPerformanceModalTab(tab);
    setPerformanceModal(true);
  };

  // Corretor não tem "Ver detalhes": os cards de agendamento não abrem a modal.
  const onCardAgendamentoClick = (tab: number) =>
    isCorretorHome ? undefined : () => abrirDetalhes(tab);

  useEffect(() => {
    requestIndicators();
    requestTemperature();
  }, []);

  const handleChangeTab = (event: any, newValue: any) => {
    setTabValue(newValue);
  };

  function TabPanel(props: any) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <>{children}</>}
      </div>
    );
  }

  function thisProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const requestIndicators = async () => {
    setLoading(true);
    try {
      const response = await axiosLead.GetHomeIndicators();
      setIndicators(response.data.data);
    } catch (error: any) {
      console.log(
        error?.response?.data?.notifications
          ? error?.response?.data?.notifications?.map(
              (item: any) => `${item.message}\n`
            )
          : "Erro ao listar indicadores"
      );
    }
    setLoading(false);
  };

  const requestTemperature = async () => {
    try {
      const response = await axiosLead.GetTemperature();
      setTemperaturas(response.data.data);
    } catch (error) {
      console.log("Erro ao listar temperaturas");
    }
  };

  const {
    refetch: refetchAtualizarIndicadores,
    isFetching: isFetchingAtualizarIndicadores,
  } = useAtualizarIndicadores({ onSuccess: () => requestIndicators() });

  const { data: dataEtapa, refetch: refetchEtapas } = useGetEtapas();

  useEffect(() => {
    refetchEtapas();
  }, []);

  const findValueEtapaByNome = (nomeEtapa: string) => {
    return dataEtapa?.find((etapa: any) => etapa?.nome === nomeEtapa);
  };

  const handleAtualizarIndicadores = () => {
    refetchAtualizarIndicadores();
  };

  const isGerente =
    props.codigoCargo2013 === CARGO_CODES.GERENTE_VENDAS ||
    props.codigoCargo2013 === CARGO_CODES.GERENTE_CIA ||
    props.codigoCargo2013 === CARGO_CODES.GERENTE_GERAL ||
    props.codigoCargo2013 === CARGO_CODES.GERENTE_COMERCIAL;
  const isSuperintendente =
    props.codigoCargo2013 === CARGO_CODES.SUPERINTENDENTE;
  const isDiretor = props.codigoCargo2013 === CARGO_CODES.DIRETOR;

  return (
    <Styles.Indicators>
      <Styles.IndicatorsHeader>
        <Styles.IndicatorsTitle>
          Indicadores da sua carteira (
          {indicators?.quantidadeIndicadoresCarteira >= 0
            ? indicators?.quantidadeIndicadoresCarteira
            : "--"}
          )
        </Styles.IndicatorsTitle>
        <Styles.IndicatorsActionsContainer>
          <Styles.IndicatorsButtonsGroup>
            {(isGerente || isSuperintendente || isDiretor) && (
              <Styles.AtualizarIndicadoresBtn
                type="button"
                onClick={() => abrirDetalhes(0)}
                style={{ justifyContent: "center" }}
              >
                <IconsSVG.UserIconMin />
                VER DETALHES
              </Styles.AtualizarIndicadoresBtn>
            )}
            {props.codigoCargo2013 === "219.840.002" ? (
              <></>
            ) : (
              <>
                {isFetchingAtualizarIndicadores ? (
                  <Skeleton variant="rounded" width="150px" height="37px" />
                ) : (
                  <Styles.AtualizarIndicadoresBtn
                    onClick={handleAtualizarIndicadores}
                  >
                    <IconsSVG.ReloadIcon />
                    Atualizar indicadores
                  </Styles.AtualizarIndicadoresBtn>
                )}
              </>
            )}
          </Styles.IndicatorsButtonsGroup>
          {usuarioGerenteOnline && (
            <Styles.GerenteOnlineBadge $withAutoMargin>
              <Styles.GerenteOnlineBadgeIcon
                src={CyrelaLogo}
                alt="Logo Cyrela"
              />
              Dados referentes à mídia Online Cyrela
            </Styles.GerenteOnlineBadge>
          )}
          {tabValue === 1 || tabValue === 2 ? (
            <WeekStyles.WeekToggle style={{ marginLeft: "auto" }}>
              <WeekStyles.WeekButton
                type="button"
                active={semanaAgendamento}
                onClick={() => setSemanaAgendamento(true)}
              >
                Semana atual ({formatIntervaloSemana(true)})
              </WeekStyles.WeekButton>
              <WeekStyles.WeekButton
                type="button"
                active={!semanaAgendamento}
                onClick={() => setSemanaAgendamento(false)}
              >
                Semana anterior ({formatIntervaloSemana(false)})
              </WeekStyles.WeekButton>
            </WeekStyles.WeekToggle>
          ) : null}
        </Styles.IndicatorsActionsContainer>
      </Styles.IndicatorsHeader>
      <PerformanceModal
        open={performanceModal}
        onClose={() => setPerformanceModal(false)}
        initialTab={performanceModalTab}
      />
      <Styles.Box>
        <Styles.Tabs
          indicatorColor="secondary"
          value={tabValue}
          onChange={handleChangeTab}
          aria-label="basic tabs example"
        >
          <Styles.Tab label="Atualização" {...thisProps(0)} />
          <Styles.Tab label="Visita" {...thisProps(1)} />
          <Styles.Tab label="Agendamento Assinatura" {...thisProps(2)} />
          <Styles.Tab label="Temperatura" {...thisProps(3)} />
          <Styles.Tab label="Etapa" {...thisProps(4)} />
        </Styles.Tabs>
      </Styles.Box>
      <TabPanel value={tabValue} index={0}>
        <Styles.RowIndicators>
          <CardIndicator
            icon={<IconsSVG.SuccessIconGreen />}
            number={
              indicators?.indicadoresFarolLead?.atualizado >= 0
                ? indicators?.indicadoresFarolLead?.atualizado
                : "--"
            }
            text="Atualizados"
            background="rgba(76, 175, 80, 0.2)"
            color="#4CAF50"
            type="status"
            idStatus={[1]}
          />
          <CardIndicator
            icon={<IconsSVG.AlertIconOrange />}
            number={
              indicators?.indicadoresFarolLead?.desatualizara >= 0
                ? indicators?.indicadoresFarolLead?.desatualizara
                : "--"
            }
            text="Desatualizará em breve"
            textShort="Desatualizará"
            background="rgba(237, 108, 2, 0.2)"
            color="#ED6C02"
            type="status"
            idStatus={[2]}
          />
          <CardIndicator
            icon={<IconsSVG.ClockIconRed />}
            number={
              indicators?.indicadoresFarolLead?.desatualizado >= 0
                ? indicators?.indicadoresFarolLead?.desatualizado
                : "--"
            }
            text="Desatualizados"
            background="rgba(244, 54, 54, 0.2)"
            color="#F43636"
            type="status"
            idStatus={[3]}
          />
        </Styles.RowIndicators>
        {indicators?.indicadoresFarolLead?.semDefinicao && (
          <Styles.NotDefined>
            <IconsSVG.IndicatorAlert className="icon-alert" />
            {indicators?.indicadoresFarolLead?.semDefinicao}
          </Styles.NotDefined>
        )}
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <Styles.RowIndicatorsAgendamento>
          <CardIndicator
            icon={<IconsSVG.CalendarTaskIcon color="#2196F3" />}
            number={
              (indicadorVisita?.agendamentosDaSemana ?? -1) >= 0
                ? String(indicadorVisita?.agendamentosDaSemana)
                : "--"
            }
            text="Agendados da semana"
            background="rgba(33, 150, 243, 0.12)"
            color="#2196F3"
            type="agendamento"
            onCustomClick={onCardAgendamentoClick(1)}
          />
          <CardIndicator
            icon={<IconsSVG.SuccessIconGreen />}
            number={
              indicadorVisita?.visitasComAgendamento != null
                ? String(indicadorVisita?.visitasComAgendamento)
                : "--"
            }
            text="Visitas realizadas com agendamento"
            textShort="Visitas c/ agendamento"
            percentual={indicadorVisita?.percentualConversao ?? null}
            percentColor="#4CAF50"
            background="rgba(76, 175, 80, 0.12)"
            color="#4CAF50"
            type="agendamento"
            onCustomClick={onCardAgendamentoClick(1)}
          />
          <CardIndicator
            icon={<IconsSVG.SuccessIconGreen />}
            number={
              indicadorVisita?.visitasSemAgendamento != null
                ? String(indicadorVisita?.visitasSemAgendamento)
                : "--"
            }
            text="Visitas realizadas sem agendamento"
            textShort="Visitas s/ agendamento"
            background="rgba(76, 175, 80, 0.12)"
            color="#4CAF50"
            type="agendamento"
            onCustomClick={onCardAgendamentoClick(1)}
          />
          <CardIndicator
            icon={<IconsSVG.ClockIcon color="#ED6C02" />}
            number={
              (indicadorVisita?.agendamentosParaHoje ?? -1) >= 0
                ? String(indicadorVisita?.agendamentosParaHoje)
                : "--"
            }
            text="Agendamentos para hoje"
            textShort="Para hoje"
            background="rgba(237, 108, 2, 0.12)"
            color="#ED6C02"
            type="agendamento"
            onCustomClick={onCardAgendamentoClick(1)}
          />
        </Styles.RowIndicatorsAgendamento>
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <Styles.RowIndicatorsAgendamento>
          <CardIndicator
            icon={<IconsSVG.CalendarTaskIcon color="#2196F3" />}
            number={
              (indicadorAssinatura?.agendamentosDaSemana ?? -1) >= 0
                ? String(indicadorAssinatura?.agendamentosDaSemana)
                : "--"
            }
            text="Agendados da semana"
            background="rgba(33, 150, 243, 0.12)"
            color="#2196F3"
            type="agendamento"
            onCustomClick={onCardAgendamentoClick(2)}
          />
          <CardIndicator
            icon={<IconsSVG.SuccessIconGreen />}
            number={
              indicadorAssinatura?.comparecimento != null
                ? String(indicadorAssinatura?.comparecimento)
                : "--"
            }
            text="Comparecimentos para assinatura"
            textShort="Comparecimentos"
            percentual={indicadorAssinatura?.percentualConversao ?? null}
            percentColor="#4CAF50"
            background="rgba(76, 175, 80, 0.12)"
            color="#4CAF50"
            type="agendamento"
            onCustomClick={onCardAgendamentoClick(2)}
          />
          <CardIndicator
            icon={<IconsSVG.ClockIcon color="#ED6C02" />}
            number={
              (indicadorAssinatura?.agendamentosParaHoje ?? -1) >= 0
                ? String(indicadorAssinatura?.agendamentosParaHoje)
                : "--"
            }
            text="Agendamentos para hoje"
            textShort="Para hoje"
            background="rgba(237, 108, 2, 0.12)"
            color="#ED6C02"
            type="agendamento"
            onCustomClick={onCardAgendamentoClick(2)}
          />
        </Styles.RowIndicatorsAgendamento>
      </TabPanel>
      <TabPanel value={tabValue} index={3}>
        <Styles.RowIndicators>
          <CardIndicator
            icon={<IconsSVG.FrioIconBlue />}
            number={
              indicators?.indicadoresTemperaturaLead?.frio >= 0
                ? indicators?.indicadoresTemperaturaLead?.frio
                : "--"
            }
            text="Frio"
            background="rgba(33, 150, 243, 0.2)"
            color="#2196F3"
            type="temperatura"
            temperaturas={temperaturas}
          />
          <CardIndicator
            icon={<IconsSVG.MornoIconYellow />}
            number={
              indicators?.indicadoresTemperaturaLead?.morno >= 0
                ? indicators?.indicadoresTemperaturaLead?.morno
                : "--"
            }
            text="Morno"
            background="rgba(255, 215, 92, 0.2)"
            color="#E4B82E"
            type="temperatura"
            temperaturas={temperaturas}
          />
          <CardIndicator
            icon={<IconsSVG.QuenteIconRed />}
            number={
              indicators?.indicadoresTemperaturaLead?.quente >= 0
                ? indicators?.indicadoresTemperaturaLead?.quente
                : "--"
            }
            text="Quente"
            background="rgba(244, 54, 54, 0.2)"
            color="#F43636"
            type="temperatura"
            temperaturas={temperaturas}
          />
        </Styles.RowIndicators>
        {indicators?.indicadoresTemperaturaLead?.semDefinicao && (
          <Styles.NotDefined>
            <IconsSVG.IndicatorAlert className="icon-alert" />
            {indicators?.indicadoresTemperaturaLead?.semDefinicao}
          </Styles.NotDefined>
        )}
      </TabPanel>
      <TabPanel value={tabValue} index={4}>
        <Styles.RowIndicators>
          <CardIndicator
            icon={<IconsSVG.IndicatorUserIcon />}
            number={
              indicators?.indicadoresEtapaLead?.novoLead >= 0
                ? indicators?.indicadoresEtapaLead?.novoLead
                : "--"
            }
            text="Novo lead"
            background="#FFFFFF"
            color="#424248"
            border="1px solid #ECECEC"
            type="etapa"
            idEtapa={dataEtapa && [findValueEtapaByNome("Novo Lead")?.id]}
          />
          <CardIndicator
            icon={<IconsSVG.IndicatorPhoneIcon />}
            number={
              indicators?.indicadoresEtapaLead?.emContato >= 0
                ? indicators?.indicadoresEtapaLead?.emContato
                : "--"
            }
            text="Em contato"
            background="#FFFFFF"
            color="#424248"
            border="1px solid #ECECEC"
            type="etapa"
            idEtapa={dataEtapa && [findValueEtapaByNome("Em Contato")?.id]}
          />
          <CardIndicator
            icon={<IconsSVG.UpdatedOutlined width={26} height={20} />}
            number={
              indicators?.indicadoresEtapaLead?.emNutricao >= 0
                ? indicators?.indicadoresEtapaLead?.emNutricao
                : "--"
            }
            text="Em Nutrição"
            background="#FFFFFF"
            color="#424248"
            border="1px solid #ECECEC"
            type="etapa"
            idEtapa={dataEtapa && [findValueEtapaByNome("Em Nutrição")?.id]}
          />
        </Styles.RowIndicators>
        <Styles.RowIndicators
          style={{ justifyContent: "left", gap: "0.8125rem" }}
        >
          <CardIndicator
            icon={<IconsSVG.IndicatorStoreIcon />}
            number={
              indicators?.indicadoresEtapaLead?.visita >= 0
                ? indicators?.indicadoresEtapaLead?.visita
                : "--"
            }
            text="Visita"
            background="#FFFFFF"
            color="#424248"
            border="1px solid #ECECEC"
            type="etapa"
            idEtapa={dataEtapa && [findValueEtapaByNome("Visita")?.id]}
          />
          <CardIndicator
            icon={<IconsSVG.EmNegociacaoIcon width={16} height={18} />}
            number={
              indicators?.indicadoresEtapaLead?.negociacao >= 0
                ? indicators?.indicadoresEtapaLead?.negociacao
                : "--"
            }
            text="Em negociação"
            background="#FFFFFF"
            color="#424248"
            border="1px solid #ECECEC"
            type="etapa"
            idEtapa={dataEtapa && [findValueEtapaByNome("Em Negociação")?.id]}
          />
          <CardIndicator
            icon={<IconsSVG.VendidoIcon width={24} height={18} />}
            number={
              indicators?.indicadoresEtapaLead?.comprou >= 0
                ? indicators?.indicadoresEtapaLead?.comprou
                : "--"
            }
            text="Comprou"
            background="#FFFFFF"
            color="#424248"
            border="1px solid #ECECEC"
            type="etapa"
            idEtapa={dataEtapa && [findValueEtapaByNome("Comprou")?.id]}
          />
          {props.codigoCargo2013 === "219.840.000" ||
          props.codigoCargo2013 === "219.840.001" ? (
            <CardIndicator
              icon={<PiHandbagSimpleDuotone size={20} />}
              number={
                indicators?.indicadoresEtapaLead?.bolsao >= 0
                  ? indicators?.indicadoresEtapaLead?.bolsao
                  : "--"
              }
              text="Bolsão"
              background="#FFFFFF"
              color="#424248"
              border="1px solid #ECECEC"
              type="etapa"
              idEtapa={dataEtapa && [findValueEtapaByNome("Bolsão")?.id]}
            />
          ) : null}
        </Styles.RowIndicators>
        {indicators?.indicadoresEtapaLead?.semDefinicao && (
          <Styles.NotDefined>
            <IconsSVG.IndicatorAlert className="icon-alert" />
            {indicators?.indicadoresEtapaLead?.semDefinicao}
          </Styles.NotDefined>
        )}
      </TabPanel>
    </Styles.Indicators>
  );
};
export default Indicators;
